module.exports = __webpack_public_path__ + "img/guangquan.11171f83.png";